import { Link } from "react-router-dom"
import styled from "styled-components"

export const UpdateBodyWrapper = styled.div`
  height: 100%;
  background: var(--color-app-dark-linear-background);
`

export const UpdateBodyContent = styled.div`
  padding: 24px var(--app-horizontal-padding) 0 var(--app-horizontal-padding);
  height: calc(100% - var(--header-height));
  color: #fff;
  display: flex;
  flex-direction: column;
`

export const TitleBox = styled.div`
  display: flex;
  padding: var(--spacing_xs, 6px) 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing_xxs, 4px);
`
export const MetricContainer = styled.div`
  padding: 12px 0;
  display: flex;
  justify-content: center;
`

export const Description = styled.p`
  color: var(--White_80, rgba(255, 255, 255, 0.8));
  font-size: 14px;
  font-weight: 400;
  line-height: 160%;
  margin: 0px;
  padding: 0px;
`

export const UpdateBodyHeader = styled.div`
  display: flex;
  align-items: center;
  height: var(--header-height);
  padding: 0 14px;
  color: #fff;
`

export const BackLink = styled(Link)`
  display: flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
`
